import { render, staticRenderFns } from "./NewWarningBox.vue?vue&type=template&id=33e507a7&scoped=true"
import script from "./NewWarningBox.vue?vue&type=script&lang=js"
export * from "./NewWarningBox.vue?vue&type=script&lang=js"
import style0 from "./NewWarningBox.vue?vue&type=style&index=0&id=33e507a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e507a7",
  null
  
)

export default component.exports